export default __webpack_public_path__ + "static/person1-2be6b45cc37694855547c97eee7b0b99.svg";